import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../store'; // Updated import
import { fetchEncryptids, addEncryptid } from '../store/slices/encryptidsSlice';
import { Encryptid } from '../types/encryptidTypes';

const EncryptidsPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const encryptids = useSelector((state: RootState) => state.encryptids.encryptids);
  const status = useSelector((state: RootState) => state.encryptids.status);
  const error = useSelector((state: RootState) => state.encryptids.error);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchEncryptids());
    }
  }, [status, dispatch]);

  const handleRandomEncryptidGeneration = () => {
    const newEncryptid: Encryptid = {
      id: Date.now().toString(),
      name: `Encryptid ${encryptids.length + 1}`,
      type: 'Random',
      health: Math.floor(Math.random() * 100) + 50,
      attack: Math.floor(Math.random() * 20) + 5,
      defense: Math.floor(Math.random() * 10) + 1,
      power: Math.floor(Math.random() * 100),
      aligned: Math.random() > 0.5,
      position: { x: Math.floor(Math.random() * 100), y: Math.floor(Math.random() * 100) },
    };
    dispatch(addEncryptid(newEncryptid));
  };

  const handleLLMEncryptidGeneration = async () => {
    // Implement LLM-based Encryptid generation here
    console.log('LLM Encryptid generation not implemented yet');
  };

  if (status === 'loading') {
    return <div>Loading encryptids...</div>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Encryptids</h1>
      <div className="mb-4">
        <button
          onClick={handleRandomEncryptidGeneration}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
        >
          Generate Random Encryptid
        </button>
        <button
          onClick={handleLLMEncryptidGeneration}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
        >
          Generate LLM Encryptid
        </button>
      </div>
      <ul className="space-y-2">
        {encryptids.map((encryptid: Encryptid) => (
          <li key={encryptid.id} className="bg-gray-700 p-2 rounded">
            <span className="font-semibold">{encryptid.name}</span> (Type: {encryptid.type}, Power: {encryptid.power})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EncryptidsPage;